export const CLIENTS_FETCHED = 'scenes/Clients/clients_fetched'
export const SEARCH_TERM_CHANGED = 'scenes/Clients/search_term_changed'
export const START_FETCHING = 'scenes/Clients/start_fetching'
export const FILTER_CHANGED = 'scenes/Clients/filter_changed'



// WEBPACK FOOTER //
// ./src/scenes/Clients/constants.js